import React, { createContext, useEffect, useState } from "react";
import { NamedProperty } from "sprint-common-web";

import { AspectTypesResponse } from "../../api/master-api/lookups/AspectTypesResponse";
import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";

interface IAspectTypesDataContext {
    aspectTypes: AspectType[];
    isLoading: boolean;
}

export type AspectType = NamedProperty;

export const AspectTypesDataContext = createContext<IAspectTypesDataContext>({} as IAspectTypesDataContext);

type AspectTypesDataProviderProps = React.PropsWithChildren<unknown>;

export const AspectTypesDataProvider: React.FunctionComponent<AspectTypesDataProviderProps> = ({
    children
}: AspectTypesDataProviderProps) => {
    const [aspectTypes, setAspectTypes] = useState<AspectType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getAspectTypes } = useMasterLookupsApi();

    useEffect(() => {
        setIsLoading(true);
        getAspectTypes().then((response: AspectTypesResponse) => {
            setAspectTypes(response.items);
            setIsLoading(false);
        });
    }, []);

    return (
        <AspectTypesDataContext.Provider value={{ aspectTypes, isLoading }}>{children}</AspectTypesDataContext.Provider>
    );
};
